import type { PropsWithChildren } from "react";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { PropallyAgentV1Api, ProposalMatchingUnreadCountResponse } from "../../api/generated/src";
import { shouldSkipConsoleErrorReport } from "../../api/sentryApiErrorPolicy";
import { UnreadMatchingCount } from "../../view_models/unreadMatchingCount";

const fetchUnreadCount = async (): Promise<ProposalMatchingUnreadCountResponse> => {
  return new Promise((resolve, reject) => {
    new PropallyAgentV1Api().agentV1ProposalMatchingUnreadCountGet(
      (error: object, data: ProposalMatchingUnreadCountResponse, response: object) => {
        if (error) {
          reject(response);
        } else {
          resolve(data);
        }
      }
    );
  });
};

export const UnreadMatchingProvider: React.FC<PropsWithChildren> = (props) => {
  const [, setUnreadCount] = useRecoilState(UnreadMatchingCount);
  const location = useLocation();

  useEffect(() => {
    const nonAuthPages = ["/sign-in", "/sign-up", "/reset-password", "/new-password"];
    if (nonAuthPages.includes(location.pathname)) {
      return;
    }

    let mounted = true;
    // 通常ログインと代理ログインのどちらでも、認証後の画面遷移を契機に未読件数を再同期する
    fetchUnreadCount()
      .then((response) => {
        if (!mounted) {
          return;
        }
        setUnreadCount((prev) => (prev.unread_count === response.unread_count ? prev : response));
      })
      .catch((error) => {
        // 401 / 304 / 理由コードが既知の403、および interceptor で報告済みの応答は重複送信しない
        // response なしの通信断は reject(undefined) となり、従来どおりログに出さない。
        if (error && !shouldSkipConsoleErrorReport(error)) {
          console.error(error);
        }
      });

    return () => {
      mounted = false;
    };
  }, [location.pathname, setUnreadCount]);

  return <>{props.children}</>;
};
